import { isUserHasKey } from '../../GlobalFunctions';
import TextInput from '../../components/TextInput';
import styles from './AddStudents.module.scss';

interface FormValues {
  [key: string]: string;
}

interface Props {
  values: FormValues;
}

const AddMultipleStudents = ({ values }: Props): JSX.Element => {
  const { studentName, password, ...valuesToMap } = values;
  const valuesToMapArray = Object.keys(valuesToMap);
  return (
    <div className={styles.multiInputRows}>
      {valuesToMapArray.map((name) => {
        const labelName = name.includes('studentName') ? 'Student Name' : 'Password';
        return (
          <TextInput
            key={name}
            label={labelName}
            name={name}
            type='text'
            placeholder=''
            disabled={isUserHasKey('KEY_MANAGE_STUDENTS') === null ? true : !isUserHasKey('KEY_MANAGE_STUDENTS')}
          />
        );
      })}
    </div>
  );
};

export default AddMultipleStudents;
